<template>
  <layout>
    <google-map
      :driver-list="driverList"
      :drivers-info="driversLocation"
      name="admiral-captains-location"
      class="relative"
    />
  </layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Layout from '@layouts/main';
import GoogleMap from '@components/custom/Map/';
import { PtButton } from '@pathao/ui-components/esm/Button';
import Config from '@config';
import makeRequest from '@utils/apiRequest';

export default {
  name: 'LiveMap',
  page: {
    title: 'Live Map',
  },
  components: { Layout, GoogleMap, PtButton },
  data() {
    return {
      driversLocation: [],
    };
  },
  computed: {
    ...mapGetters({
      driverList: 'drivers/drivers',
    }),
  },
  mounted() {
    this.fetchDriverList();
    this.fetchDriverLocationInfo();
  },
  methods: {
    ...mapActions({
      fetchDriverList: 'drivers/fetchDrivers',
    }),
    async fetchDriverLocationInfo() {
      const meta = {
        url: `${Config.api.baseURL}api/partners/drivers-tracking`,
      };
      const response = await makeRequest(meta);
      this.driversLocation = response.data.data;
    },
  },
};
</script>
